// Shared filter configuration for various pages.
// This file defines which fields are filterable for each resource
// and how they should behave in the generic SharedFilterBar.

export const agentFilterFields = [
  {
    key: 'is_started',
    labelKey: 'filters_field_status',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_started', value: true },
      { labelKey: 'filters_option_stopped', value: false },
    ],
  },
  {
    key: 'allow_ticket_creation',
    labelKey: 'filters_field_allow_ticket_creation',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'process_audio',
    labelKey: 'filters_field_process_audio',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'process_document',
    labelKey: 'filters_field_process_document',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'process_image',
    labelKey: 'filters_field_process_image',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'process_video',
    labelKey: 'filters_field_process_video',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'is_consumption_limit_enabled',
    labelKey: 'advanced.enable_limit',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'max_coins_consumption',
    labelKey: 'advanced.max_coins',
    type: 'numberRange',
    minKey: 'max_coins_consumption_min',
    maxKey: 'max_coins_consumption_max',
    min: 1,
  },
  {
    key: 'consumption_duration',
    labelKey: 'advanced.duration',
    type: 'numberRange',
    minKey: 'consumption_duration_min',
    maxKey: 'consumption_duration_max',
    min: 1,
  },
  {
    key: 'snooze_duration',
    labelKey: 'advanced.snooze',
    type: 'numberRange',
    minKey: 'snooze_duration_min',
    maxKey: 'snooze_duration_max',
    min: 1,
  },
  {
    key: 'processing_delay',
    labelKey: 'advanced.delay',
    type: 'numberRange',
    minKey: 'processing_delay_min',
    maxKey: 'processing_delay_max',
    min: 0,
    max: 30,
  },
  {
    key: 'processing_jitter',
    labelKey: 'advanced.jitter_percentage',
    type: 'numberRange',
    minKey: 'processing_jitter_min',
    maxKey: 'processing_jitter_max',
    min: 0,
    max: 100,
  },
  {
    key: 'is_processing_delay_enabled',
    labelKey: 'advanced.enable_delay',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'created_at',
    labelKey: 'filters_field_date_created',
    type: 'dateRange',
    // Backend expects created_at_start / created_at_end
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'filters_field_last_updated',
    // Date range in the UI (start & end), mapped directly to
    // updated_at_start / updated_at_end for the backend.
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
];

// Filters for knowledge bases list (/knowledge-bases)
export const knowledgeBaseFilterFields = [
  {
    key: 'created_at',
    labelKey: 'filters_field_created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'filters_field_last_updated',
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
];

// Filters for transactions list (/transactions, /transactions/me)
export const transactionFilterFields = [
  {
    key: 'id',
    labelKey: 'id',
    type: 'string',
  },
  {
    key: 'user_id',
    labelKey: 'user',
    type: 'enum',
    options: [], // populated dynamically
  },
  {
    key: 'transaction_type',
    labelKey: 'filters_field_transaction_type',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_transaction_type_payment', value: 'payment' },
      { labelKey: 'filters_option_transaction_type_message', value: 'message' },
      { labelKey: 'filters_option_transaction_type_admin', value: 'admin' },
      { labelKey: 'filters_option_transaction_type_system', value: 'system' },
    ],
  },
  {
    key: 'transaction_status',
    labelKey: 'filters_field_status',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_pending', value: 'pending' },
      { labelKey: 'filters_option_completed', value: 'completed' },
      { labelKey: 'filters_option_cancelled', value: 'cancelled' },
    ],
  },
  {
    key: 'is_disabled',
    labelKey: 'filters_field_disabled',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: false },
      { labelKey: 'filters_option_disabled', value: true },
    ],
  },
  {
    key: 'coins_amount_min',
    labelKey: 'filters_field_min_coins',
    type: 'number',
    min: 0,
  },
  {
    key: 'coins_amount_max',
    labelKey: 'filters_field_max_coins',
    type: 'number',
    min: 0,
  },
  {
    key: 'created_at',
    labelKey: 'filters_field_created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'filters_field_updated_at',
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
  {
    key: 'disabled_at',
    labelKey: 'filters_field_disabled_at',
    type: 'dateRange',
    startKey: 'disabled_at_start',
    endKey: 'disabled_at_end',
  },
];

// Filters for payments list (/payments) - used by Billing -> Payment History
// Backend accepts these keys (see validate_get_all_payments):
//  - payment_status, payment_type, currency
//  - total_min/max, coins_amount_min/max
//  - created_at_start/end, paid_at_start/end (and other date ranges)
//  - is_refunded, is_disputed, has_error (booleans)
export const paymentFilterFields = [
  {
    key: 'id',
    labelKey: 'id',
    type: 'string',
  },
  {
    key: 'payment_status',
    labelKey: 'filters_field_payment_status',
    type: 'enumMulti',
    sortKey: 'payment_status',
    options: [
      { labelKey: 'filters_option_payment_status_created', value: 'created' },
      { labelKey: 'filters_option_payment_status_processing', value: 'processing' },
      { labelKey: 'filters_option_payment_status_paid', value: 'paid' },
      { labelKey: 'filters_option_payment_status_failed', value: 'failed' },
      { labelKey: 'filters_option_payment_status_refunded', value: 'refunded' },
      { labelKey: 'filters_option_payment_status_partially_refunded', value: 'partially_refunded' },
      { labelKey: 'filters_option_payment_status_disputed', value: 'disputed' },
    ],
  },
  {
    key: 'payment_type',
    labelKey: 'filters_field_payment_type',
    type: 'enumMulti',
    sortKey: 'payment_type',
    options: [
      { labelKey: 'filters_option_payment_type_checkout', value: 'checkout' },
      { labelKey: 'filters_option_payment_type_auto_reload', value: 'auto_reload' },
    ],
  },
  {
    key: 'currency',
    labelKey: 'filters_field_currency',
    type: 'enumMulti',
    sortKey: 'currency',
    options: [
      { labelKey: 'filters_option_currency_usd', value: 'USD' },
      { labelKey: 'filters_option_currency_eur', value: 'EUR' },
      { labelKey: 'filters_option_currency_gbp', value: 'GBP' },
    ],
  },
  {
    key: 'total_min',
    labelKey: 'filters_field_min_total',
    type: 'number',
    min: 0,
    sortKey: 'total',
  },
  {
    key: 'total_max',
    labelKey: 'filters_field_max_total',
    type: 'number',
    min: 0,
    sortKey: 'total',
  },
  {
    key: 'coins_amount_min',
    labelKey: 'filters_field_min_coins',
    type: 'number',
    min: 0,
    sortKey: 'coins_amount',
  },
  {
    key: 'coins_amount_max',
    labelKey: 'filters_field_max_coins',
    type: 'number',
    min: 0,
    sortKey: 'coins_amount',
  },
  {
    key: 'created_at',
    labelKey: 'filters_field_created_at',
    type: 'dateRange',
    sortKey: 'created_at',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'paid_at',
    labelKey: 'filters_field_paid_at',
    type: 'dateRange',
    sortKey: 'paid_at',
    startKey: 'paid_at_start',
    endKey: 'paid_at_end',
  },
  {
    key: 'is_refunded',
    labelKey: 'filters_field_refunded',
    type: 'enumMulti',
    sortKey: 'is_refunded',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'is_disputed',
    labelKey: 'filters_field_disputed',
    type: 'enumMulti',
    sortKey: 'is_disputed',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'has_error',
    labelKey: 'filters_field_has_error',
    type: 'enumMulti',
    sortKey: 'has_error',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
];

// Filters for users list (/users)
export const userFilterFields = [

  {
    key: 'is_admin',
    labelKey: 'filters_field_role',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_role_admin', value: true },
      { labelKey: 'filters_option_role_user', value: false },
    ],
  },
  {
    key: 'is_verified',
    labelKey: 'filters_field_verified',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_verified', value: true },
      { labelKey: 'filters_option_unverified', value: false },
    ],
  },
  {
    key: 'is_disabled',
    labelKey: 'filters_field_disabled',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: false },
      { labelKey: 'filters_option_disabled', value: true },
    ],
  },
  {
    key: 'gender',
    labelKey: 'filters_field_gender',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_gender_male', value: 'male' },
      { labelKey: 'filters_option_gender_female', value: 'female' },
    ],
  },
  {
    key: 'language',
    labelKey: 'language',
    type: 'enumMulti',
    options: [
      { label: 'English', value: 'en' },
      { label: 'Français', value: 'fr' },
      { label: 'Español', value: 'es' },
      { label: 'Deutsch', value: 'de' },
      { label: '中文', value: 'zh' },
      { label: 'العربية', value: 'ar' },
    ],
  },


  {
    key: 'created_at',
    labelKey: 'filters_field_created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'filters_field_updated_at',
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
  {
    key: 'disabled_at',
    labelKey: 'filters_field_disabled_at',
    type: 'dateRange',
    startKey: 'disabled_at_start',
    endKey: 'disabled_at_end',
  },
  {
    key: 'discount_expiry',
    labelKey: 'filters_field_discount_expiry',
    type: 'dateRange',
    startKey: 'discount_expiry_start',
    endKey: 'discount_expiry_end',
  },
  {
    key: 'welcome_credit_at',
    labelKey: 'welcome_credit_at',
    type: 'dateRange',
    startKey: 'welcome_credit_at_start',
    endKey: 'welcome_credit_at_end',
  },
  {
    key: 'discount_added_at',
    labelKey: 'discount_added_at',
    type: 'dateRange',
    startKey: 'discount_added_at_start',
    endKey: 'discount_added_at_end',
  },
];

// Filters for conversations (advanced filters in Messages)
export const conversationFilterFields = [
  {
    key: 'status',
    labelKey: 'filters_field_status',
    type: 'enumMulti',
    options: [
      // Backend accepts only ConversationStatus values: 'active' | 'inactive'
      // We keep user-friendly labels but map them to backend values.
      { labelKey: 'filters_option_open', value: 'active' },
      { labelKey: 'filters_option_closed', value: 'inactive' },
    ],
  },
  {
    key: 'contact_type',
    labelKey: 'filters_field_contact_type',
    // Backend currently expects a single contact_type value
    // (ConversationService compares ContactModel.contact_type == value),
    // so we use a single-select enum instead of enumMulti.
    type: 'enum',
    options: [
      { labelKey: 'filters_option_contact_type_admin', value: 'admin' },
      { labelKey: 'filters_option_contact_type_customer', value: 'customer' },
    ],
  },
  {
    key: 'is_ignored',
    labelKey: 'filters_field_ignored',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'snoozed',
    labelKey: 'snoozed',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'is_seen_by_user',
    labelKey: 'filters_field_seen_by_user',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_seen', value: true },
      { labelKey: 'filters_option_unseen', value: false },
    ],
  },
  {
    key: 'is_virtual',
    labelKey: 'filters_field_virtual',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_virtual', value: true },
      { labelKey: 'filters_option_real', value: false },
    ],
  },
  {
    key: 'updated_time',
    labelKey: 'filters_field_last_activity',
    type: 'dateRange',
    startKey: 'updated_time_start',
    endKey: 'updated_time_end',
  },
  {
    key: 'created_at',
    labelKey: 'filters_field_created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'filters_field_updated_at',
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
];

// Filters for credentials list (/credentials)
// Backend accepts these filter keys (see API documentation):
//  - id, user_id, channel_id, channel_type, name, first_name, last_name
//  - email, credential_user_id, is_permanent_token
//  - token_expires_at_start/end, created_at_start/end, updated_at_start/end
export const credentialFilterFields = [
  {
    key: 'id',
    labelKey: 'id',
    type: 'string',
  },
  {
    key: 'channel_type',
    labelKey: 'filters_field_channel_type',
    type: 'enumMulti',
    options: [
      { labelKey: 'facebook', value: 'facebook' },
      { labelKey: 'instagram', value: 'instagram' },
      { labelKey: 'whatsapp', value: 'whatsapp' },
      { labelKey: 'telegram', value: 'telegram' },
    ],
  },
  {
    key: 'name',
    labelKey: 'name',
    type: 'string',
  },
  {
    key: 'first_name',
    labelKey: 'first_name',
    type: 'string',
  },
  {
    key: 'last_name',
    labelKey: 'last_name',
    type: 'string',
  },
  {
    key: 'email',
    labelKey: 'email',
    type: 'string',
  },
  {
    key: 'credential_user_id',
    labelKey: 'credential_user_id',
    type: 'string',
  },
  {
    key: 'is_permanent_token',
    labelKey: 'is_permanent_token',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'token_expires_at',
    labelKey: 'token_expires_at',
    type: 'dateRange',
    startKey: 'token_expires_at_start',
    endKey: 'token_expires_at_end',
  },
  {
    key: 'created_at',
    labelKey: 'created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'updated_at',
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
];

// Filters for channels list (/channels)
// Backend accepts these filter keys (see API documentation):
//  - id, agent_id, credential_id, channel_type, external_channel_id
//  - is_synchronization_enabled, is_permanent_token
//  - token_expires_at_start/end, created_at_start/end, updated_at_start/end
// Note: is_virtual filter is automatically applied as false in useChannelFetching hook
export const channelFilterFields = [
  {
    key: 'id',
    labelKey: 'id',
    type: 'string',
  },
  {
    key: 'channel_type',
    labelKey: 'filters_field_channel_type',
    type: 'enumMulti',
    options: [
      { labelKey: 'whatsapp', value: 'whatsapp' },
      { labelKey: 'messenger', value: 'messenger' },
      { labelKey: 'facebook', value: 'facebook_page' },
      { labelKey: 'instagram', value: 'instagram' },
    ],
  },
  {
    key: 'agent_id',
    labelKey: 'agent',
    type: 'string',
  },
  {
    key: 'credential_id',
    labelKey: 'credential',
    type: 'string',
  },
  {
    key: 'external_channel_id',
    labelKey: 'external_channel_id',
    type: 'string',
  },
  {
    key: 'is_synchronization_enabled',
    labelKey: 'filters_field_synchronization',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_enabled', value: true },
      { labelKey: 'filters_option_disabled', value: false },
    ],
  },
  {
    key: 'is_permanent_token',
    labelKey: 'is_permanent_token',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'token_expires_at',
    labelKey: 'token_expires_at',
    type: 'dateRange',
    startKey: 'token_expires_at_start',
    endKey: 'token_expires_at_end',
  },
  {
    key: 'created_at',
    labelKey: 'created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'updated_at',
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
];

// Sort fields for channels
export const channelSortFields = [
  { value: 'channel_type', labelKey: 'filters_field_channel_type' },
  { value: 'external_channel_id', labelKey: 'external_channel_id' },
  { value: 'name', labelKey: 'name' },
  { value: 'is_synchronization_enabled', labelKey: 'filters_field_synchronization' },
  { value: 'token_expires_at', labelKey: 'token_expires_at' },
  { value: 'is_permanent_token', labelKey: 'is_permanent_token' },
  { value: 'created_at', labelKey: 'created_at' },
  { value: 'updated_at', labelKey: 'updated_at' },
];


// Filters for contacts list (/contacts)
// Backend accepts these filter keys (see API documentation):
//  - id, channel_id, agent_id, first_name, last_name, full_name, profile_url, note
//  - contact_type, external_contact_id, locale, timezone, gender, email, phone
//  - is_ignored, is_snoozed, created_at_start/end, updated_at_start/end
export const contactFilterFields = [
  {
    key: 'contact_type',
    labelKey: 'contact_type',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_contact_type_admin', value: 'admin' },
      { labelKey: 'filters_option_contact_type_customer', value: 'customer' },
    ],
  },
  {
    key: 'gender',
    labelKey: 'gender',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_gender_male', value: 'male' },
      { labelKey: 'filters_option_gender_female', value: 'female' },
    ],
  },
  {
    key: 'ignored',
    labelKey: 'ignored',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'snoozed',
    labelKey: 'filters_field_snoozed',
    type: 'enumMulti',
    options: [
      { labelKey: 'filters_option_yes', value: true },
      { labelKey: 'filters_option_no', value: false },
    ],
  },
  {
    key: 'locale',
    labelKey: 'locale',
    type: 'string',
  },
  {
    key: 'email',
    labelKey: 'email',
    type: 'string',
  },
  {
    key: 'phone',
    labelKey: 'phone',
    type: 'string',
  },
  {
    key: 'created_at',
    labelKey: 'created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'updated_at',
    labelKey: 'updated_at',
    type: 'dateRange',
    startKey: 'updated_at_start',
    endKey: 'updated_at_end',
  },
];

// Sort fields for contacts
export const contactSortFields = [
  { value: 'first_name', labelKey: 'first_name' },
  { value: 'last_name', labelKey: 'last_name' },
  { value: 'full_name', labelKey: 'full_name' },
  { value: 'contact_type', labelKey: 'filters_field_contact_type' },
  { value: 'locale', labelKey: 'locale' },
  { value: 'email', labelKey: 'email' },
  { value: 'phone', labelKey: 'phone' },
  { value: 'is_ignored', labelKey: 'filters_field_ignored' },
  { value: 'is_snoozed', labelKey: 'filters_field_snoozed' },
  { value: 'created_at', labelKey: 'created_at' },
  { value: 'updated_at', labelKey: 'updated_at' },
];


// Filters for data exports list (/data-exports) - used by Settings -> Data Exports
// Backend accepts:
//  - status (string or list)
//  - created_at_start/end, updated_at_start/end, started_at_start/end, completed_at_start/end
//  - id (encoded id string or list)
export const dataExportFilterFields = [
  {
    key: 'status',
    labelKey: 'status',
    type: 'enumMulti',
    options: [
      { labelKey: 'pending', value: 'pending' },
      { labelKey: 'processing', value: 'processing' },
      { labelKey: 'completed', value: 'completed' },
      { labelKey: 'failed', value: 'failed' },
    ],
  },
  {
    key: 'created_at',
    labelKey: 'filters_field_created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'completed_at',
    labelKey: 'completion_date',
    type: 'dateRange',
    startKey: 'completed_at_start',
    endKey: 'completed_at_end',
  },
  {
    key: 'id',
    labelKey: 'id',
    type: 'string',
  },
];

export const ticketFilterFields = [
  {
    key: 'status',
    labelKey: 'ticket_status',
    type: 'enumMulti',
    options: [
      { labelKey: 'ticket_status_open', value: 'open' },
      { labelKey: 'ticket_status_in_progress', value: 'in_progress' },
      { labelKey: 'ticket_status_resolved', value: 'resolved' },
      { labelKey: 'ticket_status_closed', value: 'closed' },
    ],
  },
  {
    key: 'priority',
    labelKey: 'ticket_priority',
    type: 'enumMulti',
    options: [
      { labelKey: 'ticket_priority_low', value: 'low' },
      { labelKey: 'ticket_priority_medium', value: 'medium' },
      { labelKey: 'ticket_priority_high', value: 'high' },
      { labelKey: 'ticket_priority_urgent', value: 'urgent' },
    ],
  },
  {
    key: 'created_at',
    labelKey: 'filters_field_created_at',
    type: 'dateRange',
    startKey: 'created_at_start',
    endKey: 'created_at_end',
  },
  {
    key: 'resolved_at',
    labelKey: 'resolved_at',
    type: 'dateRange',
    startKey: 'resolved_at_start',
    endKey: 'resolved_at_end',
  },
  {
    key: 'closed_at',
    labelKey: 'closed_at',
    type: 'dateRange',
    startKey: 'closed_at_start',
    endKey: 'closed_at_end',
  },
];
